import { useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { AutoPoPartialPurchaseOrderFields } from 'src/contexts/EmailPurchaseOrderContext';
import { useOffices } from 'src/hooks/api/useOffices';
import { newBigIntId } from 'src/utils/idUtils';
import { posChangedField } from 'src/utils/posFieldUtils';
import {
  PurchaseOrderDetailsInput,
  toPartialPurchaseOrderToPurchaseOrderDetailsInput,
} from 'src/utils/purchaseUtils';
import { PurchaseOrderDetails } from 'src/WebApiController';

export const usePurchaseOrderDefaultValues = (
  purchase: PurchaseOrderDetails | null | undefined,
  poInput: PurchaseOrderDetailsInput | null,
  partialPurchaseOrder: AutoPoPartialPurchaseOrderFields | undefined,
  activeAccountUserId: string | null | undefined,
  accountCurrencyCode: string | null | undefined
) => {
  const { loginContext } = useAppContext();
  const isOfficeEnabled =
    loginContext?.user?.activeAccount?.isOfficeEnabled === true;
  const { query: officesQuery, defaultOffice } = useOffices();
  const officesData = officesQuery.data;

  return useCallback((): PurchaseOrderDetailsInput | undefined => {
    if (purchase && !poInput) {
      return undefined;
    }

    const partialInput = toPartialPurchaseOrderToPurchaseOrderDetailsInput(
      partialPurchaseOrder,
      activeAccountUserId,
      accountCurrencyCode
    );

    const freshDefaults = {
      id: newBigIntId(),
      buyerUserId: posChangedField(activeAccountUserId),
      purchaseDate: posChangedField(new Date().toISOString()),
      currencyCode: posChangedField(accountCurrencyCode),
      ticketGroupIntentions: {},
      deal: null,
      officeId: posChangedField(
        isOfficeEnabled
          ? (defaultOffice?.officeId ?? officesData?.[0]?.officeId ?? null)
          : null
      ),
    } as PurchaseOrderDetailsInput;

    return poInput ?? partialInput ?? freshDefaults;
  }, [
    purchase,
    poInput,
    partialPurchaseOrder,
    activeAccountUserId,
    accountCurrencyCode,
    isOfficeEnabled,
    officesData,
    defaultOffice,
  ]);
};
